import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EModel } from './model';
export let EFaxDocumentWorkflowActionType;
(function (EFaxDocumentWorkflowActionType) {
  EFaxDocumentWorkflowActionType["CreateDocumentInIntegrator"] = "createDocumentInIntegrator";
  EFaxDocumentWorkflowActionType["CreateReferral"] = "createReferral";
})(EFaxDocumentWorkflowActionType || (EFaxDocumentWorkflowActionType = {}));
export const fieldsFaxDocumentWorkflow = _extends({}, fieldsIBaseModel, {
  actions: {
    type: 'Object',
    array: true
  },
  categories: {
    type: 'ID',
    ref: EModel.FaxDocumentCategory,
    array: true
  },
  enabled: {
    type: 'Boolean'
  },
  name: {
    type: 'Text'
  }
});